import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { NavigationService } from '@ib-core/services/navigation.service';
import { MatSnackBarService } from '@ib-core/services/snackbar.service';
import { AuthFacadeService } from '@ib-core-services/auth-facade.service';
import { IB_ROUTES } from '@ib-enums/routes.enum';

@Component({
  selector: 'ib-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  public form: FormGroup;
  public loading = false;
  public newAttemptInSec: number;
  public isAttemptDisabled = false;
  constructor(
    private fb: FormBuilder,
    private authFacadeS: AuthFacadeService,
    private snackbar: MatSnackBarService,
    private navS: NavigationService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', Validators.required],
    });
  }

  private startTimer(): void {
    this.newAttemptInSec = 30;
    this.form.get('email').disable();
    this.isAttemptDisabled = true;
    const int = setInterval(() => {
      this.newAttemptInSec -= 1;
      if (this.newAttemptInSec === 0) {
        clearInterval(int);
        this.isAttemptDisabled = false;
        this.form.get('email').enable();
        this.newAttemptInSec = undefined;
      }
    }, 1000);
  }

  submit(): void {
    this.loading = true;
    this.authFacadeS
      .forgotPassword({
        email: this.form.get('email').value,
      })
      .subscribe({
        next: () => {
          this.snackbar.show({
            msg: 'Reset password link sent to your email',
            type: 'success',
            durationMs: 6000,
          });
          this.startTimer();
          this.loading = false;
        },
        error: () => {
          this.snackbar.show({
            msg: 'Email not found',
            type: 'error',
          });
          this.loading = false;
        },
      });
  }

  login(): void {
    this.navS.goToRoute(IB_ROUTES.LOGIN);
  }
}
